{
  "welcome": "Welcome to Harmonia",
  "landing": {
    "nav": {
      "brand": "Harmonia",
      "install": "Install",
      "cta": "Join"
    },
    "installHints": {
      "ios": {
        "title": "Install Harmonia",
        "step1": "1. Tap the Share icon in Safari",
        "step2": "2. Choose \"Add to Home Screen\"",
        "step3": "3. Confirm with \"Add\"",
        "close": "Got it"
      },
      "firefox": {
        "title": "Install Harmonia",
        "step1": "1. Open the Firefox menu (≡)",
        "step2": "2. Choose \"Install\" or \"Add to Home Screen\"",
        "step3": "3. Confirm the installation",
        "close": "Got it"
      },
      "generic": {
        "title": "Install Harmonia",
        "step1": "1. Open your browser menu",
        "step2": "2. Look for \"Install app\" or \"Add to Home Screen\"",
        "step3": "3. Confirm the installation",
        "close": "Got it"
      }
    },
    "hero": {
      "pill": "Talent Hub",
      "titleLine1": "Reveal",
      "titleLine2": "your",
      "titleHighlight": "talent",
      "titleLine3": "to the world",
      "sub": "The platform designed to inspire, connect, and propel creators, gamers, and innovators.",
      "statDisciplines": "Disciplines",
      "statConcours": "Contests",
      "statTrophees": "Live Trophies",
      "badgeTrophees": "Trophies",
      "badgeLive": "Live",
      "badgeCommunaute": "Community",
      "ctaMain": "Start the adventure",
      "ctaInstall": "Install the app",
      "ctaSecondary": "Explore the universe"
    },
    "market": {
  "chip": "PRO SOLUTION",
  "titleLine1": "Your shop,",
  "titleLine2": "your website, your world",
  "sub": "Merchants, artisans, entrepreneurs: create your shop on Harmonia and get a real website, customizable and accessible anywhere in the world — both on and off the platform.",
  "feature1Title": "Complete & customizable website",
  "feature1Desc": "Every shop becomes a full-fledged website reflecting your brand: layout, presentation, and visual identity.",
  "feature2Title": "A dedicated URL for your shop",
  "feature2Desc": "Share your shop anywhere with a functional public link, without your customers needing an account.",
  "feature3Title": "A unique URL per product",
  "feature3Desc": "Each product has its own complete page and dedicated link, ready to be shared across all your networks.",
  "feature4Title": "Present everywhere, sell everywhere",
  "feature4Desc": "Publish, showcase, and interact with your customers on all platforms, wherever they are in the world.",
  "statBoutiques": "Active shops",
  "statProduits": "Published products",
  "statMonde": "Globally accessible",
  "cta": "Create my shop"
    },
    
    "vision": {
      "chip": "OUR VISION",
      "titleLine1": "A worldwide",
      "titleLine2": "harmony",
      "sub": "We believe talent has no borders. Harmonia is the space where your ideas come to life, backed by unprecedented collective energy.",
      "card1Title": "Free creativity",
      "card1Desc": "A welcoming space designed to let your imagination run free, without barriers.",
      "card2Title": "Strong connections",
      "card2Desc": "Meet passionate minds, collaborate on new projects, and grow together.",
      "card3Title": "Constant growth",
      "card3Desc": "Surround yourself with positive energy that pushes everyone to excel every day."
    },
    "disciplines": {
      "chip": "OUR DISCIPLINES",
      "titleLine1": "Choose",
      "titleLine2": "your stage",
      "sub": "Active contests across multiple disciplines. Compete with friends, show what you've got — and win trophies awarded publicly in front of the whole community. New challenges every week.",
      "statDisciplines": "Disciplines",
      "statConcours": "Contests",
      "statHebdo": "Weekly",
      "trophyBanner": "Your talent deserves to be seen · Your victory deserves to be celebrated",
      "hint": "Tap a discipline to get started",
      "ctaTrophies": "Trophies · Awarded publicly",
      "strategie": {
        "label": "Strategy Games",
        "tagline": "Pure thought & tactics",
        "desc": "Face your opponents in intense strategy duels. Every win brings you closer to the podium.",
        "item1Name": "Awalé",
        "item1Sub": "The ancestral art of strategy",
        "item2Name": "Checkers",
        "item2Sub": "Dominate the board"
      },
      "connaissance": {
        "label": "Knowledge",
        "tagline": "Test your knowledge",
        "desc": "Intellectual duels as thrilling as they are unpredictable. Top-tier knowledge deserves its crown.",
        "item1Name": "True or False",
        "item1Sub": "Challenge your friends with facts"
      },
      "arts": {
        "label": "Arts",
        "tagline": "Creativity & expression",
        "desc": "Your eye, your line, your style. Showcase your creations and get the recognition they deserve.",
        "item1Name": "Photography",
        "item1Sub": "Your eye, your signature",
        "item2Name": "Drawing",
        "item2Sub": "Your line, your world",
        "item3Name": "Design",
        "item3Sub": "Aesthetics serving intention"
      },
      "performance": {
        "label": "Performance",
        "tagline": "Take the stage",
        "desc": "Embody, captivate, transcend. Harmonia's stage awaits your consecration.",
        "item1Name": "Comedy",
        "item1Sub": "Laughter, the most universal art",
        "item2Name": "Dance",
        "item2Sub": "Every move tells a story",
        "item3Name": "Theater",
        "item3Sub": "Embody, captivate, transcend"
      },
      "musique": {
        "label": "Music",
        "tagline": "Make the stage vibrate",
        "desc": "Your voice, your instruments, your mark on the world. Great voices deserve their ovation.",
        "item1Name": "Singing",
        "item1Sub": "Your voice, your precious instrument",
        "item2Name": "Piano",
        "item2Sub": "88 keys, an infinite universe",
        "item3Name": "Guitar",
        "item3Sub": "Every chord, a statement"
      },
      "artisanat": {
        "label": "Craftsmanship",
        "tagline": "Excellence in craft",
        "desc": "Noble trades, rare mastery. Artisanal excellence deserves its podium and recognition.",
        "item1Name": "Sewing",
        "item1Sub": "The art that dresses the world",
        "item2Name": "Woodworking",
        "item2Sub": "Wood in your hands becomes art",
        "item3Name": "Hairstyling",
        "item3Sub": "Enhance, transform, reveal",
        "item4Name": "Welding",
        "item4Sub": "The precision that joins metals",
        "item5Name": "Mechanics",
        "item5Sub": "The science that keeps the world turning"
      }
    },
    "challenge": {
      "chip": "CHALLENGES & CONTESTS",
      "title": "Contests to help you shine",
      "sub": "Every discipline opens the door to weekly contests. Strategy, arts, music, performance, craftsmanship — your area of excellence definitely has its competition on Harmonia.",
      "subMobile": "Every discipline opens the door to weekly contests. Your area of excellence has its competition on Harmonia.",
      "cta": "Take on a challenge"
    },
    "community": {
      "chip": "COMMUNITY",
      "titleLine1": "An inspiring",
      "titleLine2": "family",
      "sub": "Join a mosaic of talents. Whether you're here to share your work, find inspiration, or build the future, you'll find your place.",
      "cta": "Join the community"
    },
    "final": {
      "titleLine1": "Your moment",
      "titleLine2": "has come",
      "sub": "Don't let your potential wait any longer.\nMake your voice heard today.",
      "cta": "Create my creative profile",
      "note": "The adventure starts here · Instant access · Free"
    },
    "footer": {
      "tagline": "Cultivating inspiration, together.",
      "copyright": "All rights reserved"
    }
  },
  "login": {
    "common": {
      "tagline": "Reveal Your Talent",
      "or": "or",
      "continueWithGoogle": "Continue with Google",
      "needHelp": "Need help?",
      "loading": "Loading...",
      "emailPlaceholder": "Email",
      "passwordPlaceholder": "Password"
    },
    "login": {
      "title": "Login",
      "subtitle": "Welcome! Sign in to continue",
      "forgotPassword": "Forgot password?",
      "submit": "Sign in",
      "noAccountPrefix": "Not registered yet?",
      "noAccountLink": "Create an account"
    },
    "signup": {
      "title": "Sign Up",
      "subtitle": "Create your Harmonia account",
      "lastNamePlaceholder": "Last name",
      "firstNamePlaceholder": "First name",
      "passwordPlaceholder": "Password (min. 6 characters)",
      "submit": "Create my account",
      "alreadyAccountPrefix": "Already have an account?",
      "alreadyAccountLink": "Sign in"
    },
    "verify": {
      "title": "Verify your email",
      "subtitle": "A confirmation link has been sent to",
      "step1": "Check your inbox",
      "step2": "Click the confirmation link",
      "step3": "Come back here and click \"Verify\"",
      "submit": "Verify activation",
      "backToSignup": "Back to sign up"
    },
    "reset": {
      "title": "Forgot password",
      "subtitle": "Enter your email to receive a reset link",
      "submit": "Send link",
      "backToLogin": "Back to login",
      "confirm": {
        "checkingLink": "Checking link...",
        "title": "New password",
        "subtitle": "Choose a new secure password for your account.",
        "newPasswordPlaceholder": "New password",
        "confirmPasswordPlaceholder": "Confirm password",
        "submit": "Reset my password",
        "backToLogin": "Back to login",
        "backToLoginArrow": "← Back to login",
        "invalidLink": {
          "title": "Invalid link",
          "subtitle": "This link is invalid or has expired.\nPlease request a new password reset."
        },
        "messages": {
          "fillBothFields": "Please fill in both fields",
          "passwordTooShort": "Password must be at least 6 characters",
          "passwordsDoNotMatch": "Passwords do not match",
          "resetting": "Resetting...",
          "resetError": "Error while resetting password",
          "passwordChanged": "Password changed successfully!",
          "cannotResetPassword": "Unable to reset password"
        }
      }
    },
    "confirmGoogle": {
      "title": "Confirm identity",
      "subtitle": "Continue as",
      "submit": "Continue",
      "cancel": "Cancel"
    },
    "terms": {
      "prefix": "I have read and accept the ",
      "cgu": "Terms of Use",
      "middle": ", the ",
      "privacy": "Privacy Policy",
      "and": " and the ",
      "community": "Community Rules"
    },
    "google": {
      "defaultUser": "User"
    },
    "messages": {
      "mustAcceptTerms": "You must accept the terms of use to continue",
      "fillAllFields": "Please fill in all fields",
      "passwordTooShort": "Password must be at least 6 characters",
      "invalidDate": "Invalid date format",
      "registrationsClosed": "Registrations are currently closed.",
      "cannotVerifyRegistrations": "Unable to verify registrations.",
      "cannotReachServer": "Unable to reach the server.",
      "creatingAccount": "Creating account...",
      "signupError": "Error during sign up",
      "accountCreated": "Account created! Check your email.",
      "cannotCreateAccount": "Unable to create account",
      "verifying": "Verifying...",
      "verificationError": "Verification error",
      "emailVerified": "Email verified! Welcome to Harmonia!",
      "emailNotVerified": "Email not verified. Click the link in your email.",
      "cannotVerifyEmail": "Unable to verify email",
      "enterEmailPassword": "Please enter your email and password",
      "loggingIn": "Signing in...",
      "emailNotConfirmed": "Email not confirmed. Check your inbox.",
      "incorrectCredentials": "Incorrect credentials",
      "loginSuccess": "Signed in successfully! Welcome!",
      "cannotLogin": "Unable to sign in",
      "enterEmail": "Please enter your email",
      "sendingEmail": "Sending email...",
      "noAccountWithEmail": "No account with this email",
      "resetRequestError": "Error processing request",
      "linkSent": "Link sent! Check your inbox.",
      "cannotSendEmail": "Unable to send email",
      "googleWebFailed": "Google web sign-in failed",
      "googleTokenMissing": "Missing Google authentication token",
      "googleCancelled": "Google sign-in cancelled",
      "googleFailed": "Google sign-in could not be completed",
      "googleInProgress": "Google sign-in already in progress",
      "playServicesUnavailable": "Google Play Services are not available",
      "googleError": "Error during Google sign-in",
      "certifyingIdentity": "Certifying your identity...",
      "googleServerValidationFailed": "Google server-side validation failed",
      "welcomeUser": "Welcome, {{name}}!",
      "googleFinalizeError": "Unable to finalize Google sign-in"
    }
  },
  "guide": {
    "header": {
      "title": "User Guide",
      "gotIt": "Got it!"
    },
    "guides": {
      "create": {
        "tabLabel": "Create",
        "title": "Create my Harmonia account",
        "step1": "Tap \"Create an account\" at the bottom of the login screen.",
        "step2": "Enter your last name, first name, and date of birth.",
        "step3": "Enter a valid email address.",
        "step4": "Choose a password with at least 6 characters.",
        "step5": "Check the box to accept the Terms of Use, Privacy Policy, and Community Rules.",
        "step6": "The \"Create my account\" button becomes active — tap it.",
        "step7": "Check your inbox and click the confirmation link you received.",
        "step8": "Come back to the app and tap \"Verify activation\" to finish."
      },
      "login": {
        "tabLabel": "Sign in",
        "title": "Sign in to Harmonia",
        "step1": "Enter your email address in the first field.",
        "step2": "Enter your password in the second field.",
        "step3": "Use the 👁 icon to show or hide your password.",
        "step4": "Tap the \"Sign in\" button.",
        "step5": "You're redirected to your Harmonia space!"
      },
      "reset": {
        "tabLabel": "Forgot password",
        "title": "Forgot password",
        "step1": "On the login screen, tap \"Forgot password?\".",
        "step2": "Enter the email address linked to your Harmonia account.",
        "step3": "Tap \"Send link\".",
        "step4": "Check your inbox (also check spam!).",
        "step5": "Click the reset link received by email.",
        "step6": "Set your new password, then sign in.",
        "note": "⏱ The link expires quickly. Act as soon as you receive the email!"
      },
      "google": {
        "tabLabel": "Google",
        "title": "Sign in with Google",
        "step1": "Tap \"Continue with Google\" on the login or sign-up screen.",
        "step2": "Select your Google account in the window that opens.",
        "step3": "Review the displayed information, then tap \"Continue\".",
        "step4": "You're signed in to Harmonia!",
        "note": "💡 For sign-up via Google, check the Terms of Use box first before tapping the Google button."
      },
      "verify": {
        "tabLabel": "Email",
        "title": "Email verification",
        "step1": "After signing up, a confirmation email is sent to you automatically.",
        "step2": "Open your inbox and also check spam / junk mail.",
        "step3": "Click the \"Confirm my email\" button in the email you received.",
        "step4": "Come back to the Harmonia app.",
        "step5": "Tap \"Verify activation\" to complete your sign-up.",
        "note": "⚠️ The link is valid for 24 hours. If expired, start the sign-up process again from the beginning."
      }
    }
  },
  "notifications": {
    "header": {
      "subtitle": "Notification center"
    },
    "tabs": {
      "notifs": "Notifications",
      "last24h": "24h Info",
      "trophees": "Trophies"
    },
    "time": {
      "now": "Just now",
      "minutes_one": "{{count}} min",
      "minutes_other": "{{count}} min",
      "hours_one": "{{count}}h",
      "hours_other": "{{count}}h",
      "days_one": "{{count}}d",
      "days_other": "{{count}}d"
    },
    "types": {
      "friendRequest": "Friend request",
      "friendAccepted": "Friend accepted",
      "like": "Like",
      "comment": "Comment",
      "report": "Report",
      "postStatus": "Status",
      "default": "Announcement"
    },
    "error": {
      "notConnected": "Not connected",
      "generic": "Error {{status}}",
      "retry": "Retry"
    },
    "loading": {
      "default": "Loading…",
      "info24h": "Loading…",
      "info24hFull": "Loading the last 24 hours…"
    },
    "markAll": {
      "action": "Mark all as read"
    },
    "empty": {
      "notifs": {
        "title": "No notifications",
        "sub": "You'll be notified of activity here."
      },
      "last24h": {
        "title": "No recent activity",
        "sub": "No notifications recorded in the last 24 hours."
      },
      "trophees": {
        "title": "No trophies",
        "sub": "Join sessions to win some!"
      }
    },
    "more": {
      "loadOlder": "Load older ones"
    },
    "end": {
      "upToDate": "You're all caught up"
    },
    "info24h": {
      "title": "Activity in the last 24h",
      "count_one": "{{count}} recent notification",
      "count_other": "{{count}} recent notifications",
      "unread_one": "{{count}} unread",
      "unread_other": "{{count}} unread"
    },
    "card": {
      "grouped_one": "{{count}} grouped event",
      "grouped_other": "{{count}} grouped events"
    },
    "trophy": {
      "won_one": "trophy won",
      "won_other": "trophies won",
      "awardedBy": "Awarded by {{firstName}} {{lastName}}"
    }
  },
  "editPostModal": {
    "errors": {
      "sessionNotFound": "Session not found",
      "accessTokenMissing": "Missing access_token"
    },
    "deleteConfirm": {
      "title": "Delete this post?",
      "text": "This action is irreversible. The post will be permanently deleted.",
      "cancel": "Cancel",
      "confirm": "Delete"
    },
    "menu": {
      "title": "Post options",
      "edit": "Edit",
      "delete": "Delete",
      "cancel": "Cancel"
    },
    "edit": {
      "title": "Edit post",
      "placeholder": "What's new?",
      "save": "Save"
    }
  },
  "logoutModal": {
    "errors": {
      "sessionNotFound": "Session not found"
    },
    "memory": {
      "title": "Remember this account?",
      "message": "Would you like to remember this account so you can sign back in faster next time, without re-entering your password?",
      "no": "No",
      "yes": "Yes"
    },
    "confirm": {
      "title": "Sign out?",
      "message": "Are you sure you want to sign out of your account?",
      "cancel": "Cancel",
      "submit": "Sign out"
    }
  },
  "commentsModal": {
    "errors": {
      "sessionNotFound": "Session not found",
      "accessTokenMissing": "Missing access_token",
      "sendError": "Error sending",
      "title": "Error",
      "networkError": "Network error, please try again",
      "networkErrorTitle": "Network error",
      "tryAgain": "Please try again"
    },
    "time": {
      "now": "Just now",
      "minutes_one": "{{count}}min ago",
      "minutes_other": "{{count}}min ago",
      "hours_one": "{{count}}h ago",
      "hours_other": "{{count}}h ago",
      "days_one": "{{count}}d ago",
      "days_other": "{{count}}d ago"
    },
    "likesCount_one": "{{count}} like",
    "likesCount_other": "{{count}} likes",
    "liked": "Liked",
    "like": "Like",
    "reply": "Reply",
    "header": {
      "title": "Comments"
    },
    "empty": {
      "title": "No comments yet",
      "subtitle": "Be the first to comment!"
    },
    "replyingTo": "Replying to {{name}}",
    "replyPlaceholder": "Reply to {{name}}...",
    "addPlaceholder": "Add a comment..."
  },
  "groupsTab": {
    "time": {
      "now": "Just now",
      "minutes_one": "{{count}}min",
      "minutes_other": "{{count}}min",
      "hours_one": "{{count}}h",
      "hours_other": "{{count}}h",
      "days_one": "{{count}}d",
      "days_other": "{{count}}d"
    },
    "loadingData": "Loading data",
    "tabs": {
      "mine_one": "My groups ({{count}})",
      "mine_other": "My groups ({{count}})",
      "explore": "Explore"
    },
    "empty": {
      "noResults": "No results",
      "noResultsFor": "No groups for \"{{query}}\"",
      "noGroups": "You're not in any group",
      "exploreCta": "Explore groups",
      "noGroupsAvailable": "No groups available"
    },
    "lastMessage": "{{sender}}: {{content}}",
    "memberCount_one": "{{count}} member",
    "memberCount_other": "{{count}} members",
    "you": "You",
    "open": "Open",
    "join": "Join",
    "joining": "..."
  },
  "infoBanner": {
    "previous": "Previous",
    "next": "Next",
    "closeAndResume": "Close and resume",
    "news": "News",
    "reduceAndResume": "Minimize and resume reading"
  },
  "pushPromptModal": {
    "title": "Stay in the loop!",
    "subtitle": "Get important announcements, your trophies, and new Harmonia sessions directly on your device.",
    "icons": {
      "trophies": "Trophies",
      "announcements": "Announcements",
      "sessions": "Sessions"
    },
    "enableButton": "Enable notifications",
    "dismissButton": "Dismiss ({{count}}s)"
  },
  "savedPostsModal": {
    "time": {
      "now": "Just now",
      "minutes_one": "{{count}}min ago",
      "minutes_other": "{{count}}min ago",
      "hours_one": "{{count}}h ago",
      "hours_other": "{{count}}h ago",
      "days_one": "{{count}}d ago",
      "days_other": "{{count}}d ago"
    },
    "header": {
      "title": "Saved posts"
    },
    "syncing": "Syncing…",
    "tapToPlay": "Tap to play",
    "commentsCount_one": "{{count}} comment",
    "commentsCount_other": "{{count}} comments",
    "sharesCount_one": "{{count}} share",
    "sharesCount_other": "{{count}} shares",
    "empty": {
      "title": "No saved posts",
      "subtitle": "Posts you save will appear here"
    }
  },
  "sharersModal": {
    "time": {
      "now": "Just now",
      "minutes_one": "{{count}}min ago",
      "minutes_other": "{{count}}min ago",
      "hours_one": "{{count}}h ago",
      "hours_other": "{{count}}h ago",
      "days_one": "{{count}}d ago",
      "days_other": "{{count}}d ago"
    },
    "errors": {
      "sessionExpired": "Session expired",
      "loadFailed": "Unable to load shares"
    },
    "sharedAt": "Shared {{time}}",
    "header": {
      "title": "Shares",
      "titleWithCount": "Shares ({{count}})"
    },
    "loading": "Loading...",
    "retry": "Retry",
    "empty": "No shares yet"
  },
  "searchModal": {
    "time": {
      "now": "Just now",
      "minutes_one": "{{count}}min ago",
      "minutes_other": "{{count}}min ago",
      "hours_one": "{{count}}h ago",
      "hours_other": "{{count}}h ago",
      "days_one": "{{count}}d ago",
      "days_other": "{{count}}d ago"
    },
    "categories": {
      "all": "All",
      "posts": "Posts",
      "images": "Images",
      "videos": "Videos",
      "music": "Music",
      "artisanat": "Crafts"
    },
    "tapToPlay": "Tap to play",
    "commentsCount_one": "{{count}} comment",
    "commentsCount_other": "{{count}} comments",
    "sharesCount_one": "{{count}} share",
    "sharesCount_other": "{{count}} shares",
    "status": {
      "submissions": "Submissions",
      "votingOpen": "Voting open",
      "finished": "Finished"
    },
    "media": {
      "image": "image",
      "track": "track",
      "video": "video",
      "hide": "Hide",
      "viewCount_one": "View {{count}} {{label}}",
      "viewCount_other": "View {{count}} {{label}}s"
    },
    "runNumber": "Run #{{number}}",
    "voted": "Voted",
    "vote": "Vote",
    "votesCount_one": "{{count}} vote",
    "votesCount_other": "{{count}} votes",
    "header": {
      "title": "Search"
    },
    "placeholder": "Keywords, descriptions, titles…",
    "searchButton": "Search",
    "searching": "Searching…",
    "noResults": {
      "title": "No results",
      "subtitle": "Try different keywords"
    },
    "resultsCount_one": "{{count}} result",
    "resultsCount_other": "{{count}} results",
    "intro": {
      "title": "Search in Harmonia",
      "subtitle": "Posts, videos, images, sounds…\nChoose a category and type your keywords"
    }
  },
  "userProfileView": {
    "time": {
      "now": "Just now",
      "minutes_one": "{{count}}min ago",
      "minutes_other": "{{count}}min ago",
      "hours_one": "{{count}}h ago",
      "hours_other": "{{count}}h ago",
      "days_one": "{{count}}d ago",
      "days_other": "{{count}}d ago"
    },
    "tapToPlay": "Tap to play",
    "commentsCount_one": "{{count}} comment",
    "commentsCount_other": "{{count}} comments",
    "sharesCount_one": "{{count}} share",
    "sharesCount_other": "{{count}} shares",
    "loading": "Loading...",
    "profileNotFound": "Profile not found",
    "retry": "Retry",
    "memberSince": "Member since {{date}}",
    "friendsLabel": "Friends",
    "trophiesLabel": "Trophies",
    "friend": {
      "add": "Add friend",
      "pending": "Pending",
      "accept": "Accept",
      "remove": "Remove friend"
    },
    "viewPosts": "View posts",
    "postsCount": "Posts ({{count}})",
    "noPosts": "No posts",
    "notFriend": {
      "pendingSent": "Request sent — Awaiting confirmation",
      "pendingReceived": "Accept the request to see posts",
      "none": "Add this user as a friend to see their posts"
    }
  },
  "cgu": {
    "title": "Terms of Use",
    "stats": {
      "sections": "Sections",
      "law": "Beninese law",
      "compliant": "Compliant"
    },
    "sections": {
      "presentation": {
        "title": "Presentation of the platform",
        "p1": "Harmonia is a global social platform, available on web and mobile, allowing its members to create a profile, publish content, interact via messaging and groups, take part in talent contests, play trivia and strategy games, and create an online shop for PRO users.",
        "p2": "Harmonia is developed and operated by an entity registered in Benin.",
        "highlight1": "By accessing the platform and creating an account, you accept these Terms of Use without reservation."
      },
      "inscription": {
        "title": "Access and registration",
        "sub1": "Account creation",
        "p1": "Access to Harmonia's features requires creating an account. Registration is open to anyone worldwide, with no age restriction.",
        "bullets1": [
          "Direct registration: last name, first name, email address, and date of birth",
          "Via a third-party provider (Google, Facebook, etc.): last name, first name, and email address. The date of birth can be completed later."
        ],
        "sub2": "Accuracy of information",
        "p2": "You agree to provide accurate and up-to-date information when registering. Harmonia cannot be held liable for consequences related to inaccurate information.",
        "sub3": "Staying signed in",
        "highlight1": "You may choose to stay signed in to your account without re-entering your password every time you open the app. This choice is entirely yours and remains changeable at any time.",
        "sub4": "Minors",
        "highlight2": "For any subscription to a paid service (subscription, paid contest, pro shop), a minor user must obtain the explicit consent of their parent or legal guardian before any purchase."
      },
      "publications": {
        "title": "Posts and content",
        "sub1": "Daily limit",
        "bullets1": [
          "Standard users: 1 post per day",
          "PRO users: 3 posts per day"
        ],
        "p1": "This limit encourages the quality and relevance of content shared on the platform.",
        "sub2": "Visibility levels",
        "bullets2": [
          "PRO — visible to the entire Harmonia community (paid feature)",
          "Friends — visible only to your friends",
          "Friends of friends — visible to your friends and their friends",
          "Private — visible only to you"
        ],
        "sub3": "Prohibited content",
        "bullets3": [
          "Explicit sexual content or nudity",
          "Hateful, discriminatory content or content inciting violence",
          "Deliberate and malicious misinformation",
          "Infringement of a third party's intellectual property rights",
          "Content that is illegal under applicable laws"
        ],
        "sub4": "Intellectual property",
        "highlight1": "You retain full ownership of your content. Harmonia claims no rights over your creations and will never use them for promotional purposes without your consent.",
        "sub5": "Responsibility",
        "p2": "Each user is solely and fully responsible for the content they publish. Harmonia disclaims any responsibility for content published by its members."
      },
      "abonnements": {
        "title": "Subscriptions and payments",
        "sub1": "Paid features",
        "bullets1": [
          "PRO visibility: broadcast a post to the entire community",
          "Creating a pro shop and publishing associated products",
          "Data usage for personal purposes",
          "Participation in paid contests"
        ],
        "sub2": "Payment methods",
        "p1": "Harmonia accepts several payment methods: mobile payment, bank card, and other methods progressively integrated.",
        "sub3": "No-refund policy",
        "highlight1": "All purchases are final. Once a service has been granted and used, no refund will be issued, even in the event of suspension of the content, the pro shop, or a product for rule violations."
      },
      "messagerie": {
        "title": "Messaging and interactions",
        "sub1": "Private messaging",
        "p1": "Private messaging is strictly confidential and accessible only to the participants of each conversation.",
        "sub2": "Discussion groups",
        "p2": "Harmonia provides community discussion groups. Within these groups, users may also message each other privately.",
        "highlight1": "Rules of respect and courtesy also apply within private messaging."
      },
      "publicite": {
        "title": "Advertising",
        "p1": "By using Harmonia, you agree to receive advertising posts integrated into the platform.",
        "highlight1": "These ads come exclusively from users who have subscribed to a Harmonia advertising plan. No external ad network is used."
      },
      "concours": {
        "title": "Talent contests",
        "sub1": "Covered categories",
        "bullets1": [
          "Visual arts: drawing, photography",
          "Performing arts: comedy, dance",
          "Music: piano and other instruments",
          "Craftsmanship: artisanal activities and trades",
          "Strategy games: checkers, Awalé, and others",
          "Trivia: True or False and other formats"
        ],
        "highlight1": "Harmonia does not offer any games of chance. The sole objective is to reward genuine talent.",
        "sub2": "Voting system",
        "p1": "Advancement to the physical stage is determined by community votes. Voting is free, open to all authenticated users, and limited to one vote per candidate.",
        "sub3": "Final physical stage",
        "p2": "Finals may be held anywhere in the world. Host countries and expert juries are randomly selected by Harmonia to ensure fairness. Rewards include trophies, cash prizes, gifts, and other distinctions announced for each contest.",
        "sub4": "Real-time information",
        "highlight2": "All users receive real-time information about contest proceedings and platform activity, so that everyone is informed fairly."
      },
      "boutiques": {
        "title": "Pro shops",
        "sub1": "Service description",
        "p1": "PRO users can create a shop on the platform, accessible from Harmonia and via a functional public URL link on the web. They can customize the design and many settings of the site associated with their shop.",
        "highlight1": "Each product published in a shop also has its own web link enabling direct viewing.",
        "sub2": "Ownership and responsibility",
        "p2": "The PRO user retains ownership of their shop's content and is solely and fully responsible for it, including toward people who view their web links outside of Harmonia.",
        "sub3": "Compliance and suspension",
        "p3": "Shop and product content is subject to the same rules as the rest of the platform (prohibited content, community rules). Harmonia may suspend a shop, a product, or deactivate a web link in case of non-compliance, with no right to a refund."
      },
      "moderation": {
        "title": "Moderation and reporting",
        "sub1": "Reporting",
        "p1": "Any user may report content that violates the rules, including content from a pro shop or a published product. When content receives a significant number of reports, it is automatically placed under review and is no longer publicly visible.",
        "sub2": "Administrator decision",
        "bullets1": [
          "Compliant content: it regains its normal visibility",
          "Non-compliant content: it is suspended permanently and without appeal"
        ],
        "highlight1": "Harmonia does not ban users. Moderation measures target content, not people."
      },
      "api": {
        "title": "Protection of the API and systems",
        "p1": "Harmonia's backend API and all of its technical systems are the exclusive property of the platform. Access to the API is strictly reserved for official Harmonia applications.",
        "sub1": "Prohibited acts",
        "bullets1": [
          "Accessing the API outside of official applications",
          "Circumventing authentication or security mechanisms",
          "Intercepting exchanges between applications and servers",
          "Using bots, automated scripts, or scraping tools",
          "Carrying out DDoS attacks or any action disrupting the platform",
          "Exploiting technical vulnerabilities for malicious purposes",
          "Reproducing or redistributing data from the platform"
        ],
        "sub2": "Legal action",
        "highlight1": "Any violation constitutes a serious offense liable to legal action. Harmonia will cooperate with the competent authorities of any country to identify and prosecute offenders.",
        "sub3": "Responsible disclosure",
        "p2": "If you discover a security flaw, report it immediately to harmonia@harmoniaworld.world without exploiting it. Harmonia will handle any good-faith report seriously and confidentially."
      },
      "disponibilite": {
        "title": "Platform availability",
        "p1": "Harmonia strives to ensure optimal availability. Interruptions may occur for maintenance, updates, or technical circumstances beyond our control.",
        "p2": "Harmonia cannot be held liable for such interruptions."
      },
      "modifications": {
        "title": "Changes to the Terms of Use",
        "p1": "Harmonia reserves the right to modify these Terms of Use at any time. Users will be informed of any substantial change via the platform.",
        "highlight1": "Continued use after a change constitutes acceptance of the new terms."
      },
      "droit": {
        "title": "Applicable law and jurisdiction",
        "p1": "These Terms of Use are governed by Beninese law. In the event of a dispute, and failing an amicable resolution, the competent courts of Benin will have jurisdiction."
      },
      "contact": {
        "title": "Contact",
        "p1": "For any user guide to the platform, see our documentation available directly on Harmonia."
      }
    }
  },
  "confidentialite": {
    "title": "Privacy Policy",
    "stats": {
      "sections": "Sections",
      "gdpr": "GDPR Compliant",
      "secure": "Secure data"
    },
    "sections": {
      "intro": {
        "title": "Introduction",
        "p1": "Harmonia is a global social platform available on web and mobile, allowing its users to publish content, interact, take part in contests, and play trivia and strategy games.",
        "p2": "This Privacy Policy transparently informs you about the data we collect, how we use it, your rights, and the measures taken to protect your privacy.",
        "highlight1": "By using Harmonia, you accept the practices described in this policy."
      },
      "responsable": {
        "title": "Data controller",
        "p1": "The controller responsible for processing personal data collected via Harmonia is the leadership team of the Harmonia platform, an entity registered in Benin.",
        "p2": "For any question regarding your personal data, exercising your rights, or any complaint, contact us directly at this address."
      },
      "donnees": {
        "title": "Data collected",
        "sub1": "Direct registration",
        "bullets1": [
          "Last name and first name",
          "Email address",
          "Date of birth"
        ],
        "sub2": "Via a third-party provider (Google, Facebook, etc.)",
        "bullets2": [
          "Last name and first name",
          "Email address",
          "Date of birth (to be completed later)"
        ],
        "sub3": "Profile data & published content",
        "p1": "You control the visibility of each piece of profile information and each post (PRO, Friends, Friends of friends, Private).",
        "sub4": "Messaging",
        "p2": "Private messages and group discussions are strictly confidential, accessible only to the participants of each conversation.",
        "sub5": "Payment data",
        "p3": "Processed exclusively by our certified providers. Harmonia never directly stores your bank details.",
        "sub6": "Pro shops",
        "highlight1": "PRO users can create a shop with a public URL link. We collect the shop's information, the published products (each with its own web link), and the customization data of the associated site."
      },
      "utilisation": {
        "title": "Use of data",
        "bullets1": [
          "Managing your account and authentication",
          "Social features (posts, messaging, friends, groups)",
          "Contests, games, and worldwide physical final stages",
          "Real-time broadcasting of information about contests and platform activity",
          "Managing your subscriptions and paid services",
          "Creating and providing pro shops and associated web links",
          "Enforcing daily posting limits (1/day standard, 3/day PRO) to strengthen information quality",
          "Internal ads coming from subscribed users",
          "Security, fraud prevention, and content moderation"
        ],
        "highlight1": "We commit to never selling, renting, or transmitting your data to third parties for commercial purposes."
      },
      "concours": {
        "title": "Contests & Physical events",
        "p1": "Some contests lead to a physical final stage organized by Harmonia, which may take place anywhere in the world.",
        "highlight1": "Harmonia does not collect any additional data for these events. No ID document, address, or location is requested.",
        "p2": "Expert juries and host countries are randomly selected by Harmonia to ensure fairness and prevent fraud.",
        "sub1": "Real-time information",
        "p3": "Harmonia broadcasts real-time information about how contests unfold, based on data already collected in the normal course of using the platform. This broadcast does not result in any additional data collection."
      },
      "publicite": {
        "title": "Advertising",
        "p1": "By using Harmonia, you agree to receive advertising posts coming exclusively from users subscribed to a Harmonia advertising plan.",
        "highlight1": "No external ad network. No advertising from outside third parties is broadcast on Harmonia."
      },
      "securite": {
        "title": "Hosting & Security",
        "p1": "Your data is hosted on servers located in Europe, in compliance with applicable security standards.",
        "bullets1": [
          "Encryption of sensitive data",
          "Restricted data access based on roles",
          "Continuous monitoring of infrastructure",
          "Limiting the number of daily posts, to prevent abusive behavior"
        ],
        "sub1": "Protection of the API and technical systems",
        "p2": "Harmonia's backend API is reserved for exclusive internal use. Any unauthorized access is prohibited and liable to legal action. Harmonia collects technical logs (connections, IP addresses) to detect and prosecute any fraudulent access."
      },
      "partage": {
        "title": "Data sharing",
        "highlight1": "Your data is never shared for external commercial or advertising purposes.",
        "bullets1": [
          "Technical providers bound by strict contractual confidentiality obligations",
          "Legal obligations (judicial proceedings or requisition by a competent authority)"
        ],
        "p1": "The content of a pro shop (products, description, customization) is made publicly accessible via its web link once the PRO user chooses to publish their shop."
      },
      "mineurs": {
        "title": "Minor users",
        "p1": "Harmonia is accessible to all users with no age restriction. Talent has no age, and knowledge is for everyone.",
        "highlight1": "For any paid service, a minor must obtain the explicit consent of their parent or legal guardian."
      },
      "droits": {
        "title": "Your rights (GDPR)",
        "bullets1": [
          "Right of access — view your data",
          "Right to rectification — correct inaccurate data",
          "Right to erasure — delete your account and your data",
          "Right to portability — export your data",
          "Right to object — to certain processing",
          "Right to withdraw consent at any time"
        ],
        "highlight1": "To exercise your rights: harmonia@harmoniaworld.world"
      },
      "conservation": {
        "title": "Data retention",
        "p1": "Your data is retained for the entire duration of your active use of the platform.",
        "bullets1": [
          "Identifiable data deleted upon account closure",
          "Anonymized data may be retained for statistical purposes",
          "Pro shop and associated products deleted upon account closure; the associated web links stop working"
        ]
      },
      "cookies": {
        "title": "Cookies & Tracking technologies",
        "highlight1": "No third-party tracking tool (no Google Analytics, no advertising trackers).",
        "p1": "Only essential technical cookies are used (session, authentication, security). On mobile, secure authentication tokens are stored locally on your device, including when you choose to stay signed in."
      },
      "responsabilite": {
        "title": "User responsibility",
        "p1": "Each user is solely and fully responsible for the content they publish on Harmonia, including the content of a pro shop and its associated web links.",
        "p2": "Harmonia reserves the right to suspend any non-compliant content after review by its administrators, including a pro shop or a published product."
      },
      "modifications": {
        "title": "Changes to the policy",
        "p1": "Harmonia reserves the right to modify this policy at any time. In the event of a substantial change, users will be notified via the platform.",
        "highlight1": "Continued use after a change constitutes acceptance of the new terms."
      },
      "contact": {
        "title": "Contact",
        "p1": "Also see our user guide available directly on Harmonia."
      }
    }
  },
  "guideScreen": {
    "header": {
      "title": "User Guide",
      "subtitle": "Everything about Harmonia"
    },
    "intro": {
      "text": "Welcome to the user guide. Tap a chapter to expand it and discover how to use each feature.",
      "allMembers": "All members",
      "proFeatures": "PRO features"
    },
    "chapters": {
      "compte": {
        "title": "Login & Account",
        "steps": {
          "step1": {
            "title": "Create an account",
            "desc": "On the home screen, tap \"Create an account\". Enter your first name, last name, email address, and a password. Check the terms of use box, then tap \"Sign up\"."
          },
          "step2": {
            "title": "Verify your email",
            "desc": "After signing up, a verification email is sent to you. Open it and click the link to activate your account, then come back to the app."
          },
          "step3": {
            "title": "Sign in",
            "desc": "Enter your email and password, then tap \"Sign in\"."
          },
          "step4": {
            "title": "Stay signed in",
            "desc": "You can choose to stay signed in to your account. In that case, every time you open the app, you land directly on the news feed without having to re-enter your password. This choice is yours at all times: if you sign out explicitly without having enabled this option, you'll see the login screen the next time you open the app."
          },
          "step5": {
            "title": "Forgot password",
            "desc": "On the login screen, tap \"Forgot password\". Enter your email. You'll receive a 6-digit code. Enter it, then create a new password."
          },
          "step6": {
            "title": "Sign in with Google",
            "desc": "Tap \"Continue with Google\" to sign in with one click. On first sign-in, you'll need to accept the terms of use."
          }
        }
      },
      "actu": {
        "title": "News feed",
        "steps": {
          "step1": {
            "title": "Browse the feed",
            "desc": "The Feed tab 🏠 shows the community's posts. Scroll down to load more content. Tap the filter icon to sort: All · Posts · Images · Videos · Music."
          },
          "step2": {
            "title": "Hide or show the header",
            "desc": "Double-tap the header area to hide it and gain reading space. Do it again to show it back."
          },
          "step3": {
            "title": "Your CFA balance",
            "desc": "Your CFA balance is shown in the header. Tap it to open the top-up screen directly and add funds via Mobile Money."
          },
          "step4": {
            "title": "Refresh the feed",
            "desc": "Pull down from the top of the feed to refresh. You can also tap the refresh icon 🔄 in the header."
          },
          "step5": {
            "title": "Create a post",
            "desc": "Tap the \"+\" button in the header. Write your message (max 1,000 characters). Choose the visibility: Public · Friends · Private · PRO. Tap \"Post\"."
          },
          "step6": {
            "title": "Add a photo or video to your post",
            "desc": "PRO members can attach a photo or video to their posts. A 📷 Photo and 🎬 Video button appears in the creation form."
          },
          "step7": {
            "title": "Like a post",
            "desc": "Tap the thumb 👍 below a post to like it. A purple glow animates. Tap again to undo. Tap the like counter to see the list of people who liked it."
          },
          "step8": {
            "title": "Comment",
            "desc": "Tap the 💬 icon to open the post's comments. Write your reply in the text box at the bottom and send."
          },
          "step9": {
            "title": "Share a post",
            "desc": "Tap the share icon 🔄 to share a public post in the feed. Tap the displayed share count to see the list of users who shared it."
          },
          "step10": {
            "title": "Save a post",
            "desc": "Tap the 🔖 icon below a post to save it. Find all your saved posts by tapping the dedicated icon in the header."
          },
          "step11": {
            "title": "Report content",
            "desc": "Tap the report icon ⚠️ to report an inappropriate post to the Harmonia team."
          },
          "step12": {
            "title": "Edit or delete your posts",
            "desc": "On your own posts, a ✏️ icon lets you edit the text and a 🗑️ icon lets you delete it. These buttons only appear on your own posts."
          },
          "step13": {
            "title": "View an image in full size",
            "desc": "Tap an image in the feed to open it. Double-tap to display it fullscreen. Tap again to close."
          },
          "step14": {
            "title": "Play a video or audio",
            "desc": "Video posts show a ▶️ button. Music submissions have a built-in player with Play/Pause and a progress bar. Tap ❤️ to vote."
          },
          "step15": {
            "title": "Vote on creations in the feed",
            "desc": "Art and performance submissions appear in the feed. Scroll vertically to browse TikTok-style videos. Tap ❤️ to vote for your favorite."
          },
          "step16": {
            "title": "Search in the feed",
            "desc": "Tap the 🔍 icon in the header to open the search bar and find posts or users."
          },
          "step17": {
            "title": "Notifications",
            "desc": "Tap the 🔔 icon in the header to check your notifications (likes, comments, friend requests, etc.)."
          }
        }
      },
      "jeux": {
        "title": "Talent Hub",
        "steps": {
          "step1": {
            "title": "Explore the disciplines",
            "desc": "The Games tab 🎮 opens the Talent Hub with 6 categories: Strategy Games · Knowledge · Arts · Performance · Music · Craftsmanship. Scroll to see them all."
          },
          "step2": {
            "title": "Discover a game in detail",
            "desc": "Long-press (≈ 0.4s) any game to open its detail card: description, tagline, and trophy badge. Tap \"Start the adventure\" or close the card."
          },
          "step3": {
            "title": "Open a game",
            "desc": "Tap normally on a game to open it fullscreen. The ⓘ button in the header shows Harmonia's presentation banner."
          },
          "step4": {
            "title": "Join a session",
            "desc": "In each game, the \"Explore\" tab lists available sessions (free or paid in CFA). Tap \"Join\" to participate. The \"My Sessions\" tab shows the ones you've already joined."
          },
          "step5": {
            "title": "True or False — Answer a question",
            "desc": "Sessions tab → choose a session → a group. Tap \"Answer\". The question appears with a progress bar. Tap \"TRUE\" (green) or \"FALSE\" (red). Navigate between questions with Previous / Next."
          },
          "step6": {
            "title": "True or False — Locked groups",
            "desc": "Some groups require a minimum score to access. If your score is insufficient, the group shows a 🔒 icon and the required score."
          },
          "step7": {
            "title": "True or False — View your answers",
            "desc": "The \"Answers\" tab lets you review the questions you've answered and your TRUE/FALSE choice, without seeing scores."
          },
          "step8": {
            "title": "True or False — Results",
            "desc": "The \"Results\" tab shows your scores and the correct answers. This information only appears once the administrator reveals it. Before that, a \"Pending\" message is shown."
          },
          "step9": {
            "title": "Awalé & Checkers — Join and play",
            "desc": "Choose a session in \"My Sessions\". When the run starts, tap \"Play now\". A prep countdown precedes each game. You are always shown at the bottom of the board."
          },
          "step10": {
            "title": "Checkers — Play on the board",
            "desc": "Tap one of your pieces to select it — valid squares light up green (move) or orange (capture possible). Tap the destination square to play. Kings ♔ can move in all directions."
          },
          "step11": {
            "title": "Awalé — Play on the board",
            "desc": "Your pits (bottom row) light up green when it's your turn. Tap a pit containing seeds to play. The score is shown at the top. In case of a tie, a deciding \"First to 12\" round starts automatically."
          },
          "step12": {
            "title": "Match rankings (Awalé & Checkers)",
            "desc": "The \"Rankings\" tab lists your sessions. Tap a session to see the runs and each match's results (ongoing 🔵 or finished ✅) with the winner highlighted 🏆."
          },
          "step13": {
            "title": "Submit a creation — Arts",
            "desc": "\"Submit\" tab → choose an open run. Fill each slot with an image (JPG · PNG · WEBP). Add a description if you like. The send button becomes active once all slots are filled."
          },
          "step14": {
            "title": "Submit — Performance & Craftsmanship",
            "desc": "Same principle as Arts but with videos (MP4 · MOV · WEBM). All slots must be filled. Already submitted creations are locked and show the 🔒 icon."
          },
          "step15": {
            "title": "Submit — Music",
            "desc": "Select your audio files (MP3 · WAV · M4A) from your gallery. Fill all required slots, add an optional description, then send."
          },
          "step16": {
            "title": "Creative rankings & Votes",
            "desc": "The \"Rankings\" tab shows the podium 🥇🥈🥉 with each participant's ❤️ vote count. It updates as soon as voting is opened by the administrator."
          }
        }
      },
      "messages": {
        "title": "Messages",
        "steps": {
          "step1": {
            "title": "Conversation history",
            "desc": "The History tab 🕐 lists your private and group conversations. A red badge shows unread messages. The last-message preview shows an emoji based on its type: 📷 Photo · 🎬 Video · 🎵 Audio · 📁 File."
          },
          "step2": {
            "title": "Friends online",
            "desc": "The \"Online\" tab 🟢 shows your currently connected friends (green dot). Tap a friend to start a conversation directly."
          },
          "step3": {
            "title": "My friends",
            "desc": "The \"Friends\" tab 👥 lists all your friends (online or offline). Tap a name to open the conversation."
          },
          "step4": {
            "title": "Groups",
            "desc": "The \"Groups\" tab shows your group conversations. Tap a group to open it."
          },
          "step5": {
            "title": "Search a conversation",
            "desc": "Tap the 🔍 icon in the header to show the search bar. It works in every tab — History, Online, Friends, and Groups."
          },
          "step6": {
            "title": "Manual sync",
            "desc": "Tap the sync icon, directly visible in the \"Messages\" header, to start a sync. A 3-step animation appears: Initializing → Refreshing → Syncing data. Visual feedback confirms success or reports an error."
          },
          "step7": {
            "title": "Send a text message",
            "desc": "Type in the text box (max 1,000 characters) and tap ➤ to send. The status shows below your bubble: ⏳ sending · ✓ sent · ✓✓ read."
          },
          "step8": {
            "title": "Resend a failed message",
            "desc": "If a message couldn't be sent after 3 attempts, its bubble shows with a red border and a \"Retry\" 🔁 button. Tap it to resend."
          },
          "step9": {
            "title": "Send media (PRO)",
            "desc": "PRO members see a 📎 button to the left of the text box. Tap to attach an image, video, or document (PDF, Word, Excel, etc.) to your message."
          },
          "step10": {
            "title": "Record and send a voice note (PRO)",
            "desc": "When the text box is empty, PRO members see a 🎤 button. Hold to record. Tap ⏹ to stop. A preview player appears with Play/Pause, progress bar, and total duration. Tap ➤ to send or 🗑️ to cancel."
          },
          "step11": {
            "title": "Reply in a group",
            "desc": "Long-press a message to open the actions. Choose \"Reply publicly\" 🌍 (the whole group sees the reply) or \"Reply privately\" 🔒 (visible only to you and the recipient)."
          },
          "step12": {
            "title": "Change your reply's visibility",
            "desc": "Double-tap your own reply in a group to switch between public and private. The 👁 or 🚫👁 icon confirms the current state. You can also use long-press → \"Make private\" / \"Make visible\"."
          },
          "step13": {
            "title": "Delete a message",
            "desc": "Long-press one of your messages, then tap \"Delete\". The message is replaced with \"Message deleted\" for all participants."
          },
          "step14": {
            "title": "View an image fullscreen",
            "desc": "Double-tap an image in a conversation to display it fullscreen. Tap again or the ✕ to close."
          },
          "step15": {
            "title": "Offline banner",
            "desc": "If the connection is lost, a red banner appears at the top of the conversation. Your messages are queued and resent automatically once the connection returns."
          }
        }
      },
      "amis": {
        "title": "Network & Friends",
        "steps": {
          "step1": {
            "title": "Friend suggestions",
            "desc": "The Network tab 👥 shows people you might know. Scroll to load more suggestions. Tap the ➕ button to the right of a name to send them a friend request."
          },
          "step2": {
            "title": "Search for a user",
            "desc": "Tap the \"Search\" tab 🔍. Type a first or last name in the bar, then tap the → arrow to search. Tap ➕ to send a request to a result."
          },
          "step3": {
            "title": "Received requests",
            "desc": "The \"Requests\" tab 📩 shows a red badge if you have pending requests. \"Received\" sub-tab: tap \"Accept\" to become friends, or \"Decline\" to decline."
          },
          "step4": {
            "title": "Sent requests",
            "desc": "\"Sent\" sub-tab: find all your requests awaiting a reply. Tap \"Cancel\" to withdraw a request."
          },
          "step5": {
            "title": "View a user's profile",
            "desc": "In suggestions, search results, or requests, tap a user's name or avatar to open their profile card."
          }
        }
      },
      "profil": {
        "title": "My Profile",
        "steps": {
          "step1": {
            "title": "Edit your profile photo",
            "desc": "On the Profile screen, tap the orange 📷 icon on your avatar to choose a new photo from your gallery. The update is immediate."
          },
          "step2": {
            "title": "CFA balance and Trophies",
            "desc": "Two colored cards show your CFA balance 💰 and your number of trophies 🏆 won. These counters update automatically."
          },
          "step3": {
            "title": "Top up your balance",
            "desc": "Tap the \"Top up my balance\" card (gold wallet) to access the top-up screen. You can also top up from the feed by tapping your CFA balance."
          },
          "step4": {
            "title": "Edit your information",
            "desc": "Tap \"Settings\" ⚙️ in the \"My account\" section. A panel opens from the bottom with Last name, First name, and Date of birth fields. Edit, then tap \"Save\"."
          },
          "step5": {
            "title": "Privacy",
            "desc": "Tap \"Privacy\" 🛡️ to access your account's privacy, data, and security settings."
          },
          "step6": {
            "title": "Access the guide",
            "desc": "Tap \"User guide\" 📖 in the \"My account\" section to open this guide at any time."
          },
          "step7": {
            "title": "Create a post from your profile",
            "desc": "In the \"Posts\" section, tap the \"Post\" button (pink-orange gradient). The creation form opens with the same options as in the feed."
          },
          "step8": {
            "title": "Manage your posts",
            "desc": "Your posts are listed at the bottom of your profile. On each one: ✏️ to edit the text · 🗑️ to delete (a confirmation is requested). Liking, commenting, sharing, and saving actions are also available."
          },
          "step9": {
            "title": "Add media to a post (PRO)",
            "desc": "PRO members see 📷 Photo and 🎬 Video buttons in the creation form. A preview shows before publishing. Tap ✖ to remove the media."
          },
          "step10": {
            "title": "Sign out",
            "desc": "Tap the sign-out icon 🚪 at the top right of your profile. You'll be asked to confirm before actually signing out. If you had chosen to stay signed in, this sign-out is final: you'll see the login screen the next time you open the app."
          }
        }
      },
      "pro": {
        "title": "PRO Status ⭐",
        "steps": {
          "step1": {
            "title": "Visible PRO badge",
            "desc": "The ⭐ PRO badge appears on your profile and is visible to all members of the Harmonia community."
          },
          "step2": {
            "title": "Enhanced posts",
            "desc": "PRO members can attach a photo or video to their posts in the news feed. Posts with \"PRO\" visibility are only visible to other PRO members."
          },
          "step3": {
            "title": "Media in messages",
            "desc": "As a PRO member, you can send images, videos, and documents (PDF, Word, Excel, etc.) in private and group conversations."
          },
          "step4": {
            "title": "Voice notes",
            "desc": "PRO members can record and send voice notes in messages. A built-in preview player lets you listen to the recording before sending."
          },
          "step5": {
            "title": "Upgrade to PRO status",
            "desc": "Tap \"Top up my balance\" in your profile or your CFA balance in the feed. Top up your account via Mobile Money to access PRO features."
          }
        }
      },
      "market": {
        "title": "Pro Shop & Market ⭐",
        "steps": {
          "step1": {
            "title": "Open the Market",
            "desc": "A 6th \"Market\" 🛍️ button is available in the main navigation bar. Tap it: the bar scrolls and gives way to a new navigation bar dedicated to the Market, with 4 buttons: Home, All products, Shops, and Settings."
          },
          "step2": {
            "title": "Return to main navigation",
            "desc": "From the Market, tap the \"Home\" 🏠 button to return to the app's main navigation bar."
          },
          "step3": {
            "title": "Browse all products",
            "desc": "The \"All products\" button shows every product published by the platform's shops, across all sellers."
          },
          "step4": {
            "title": "Browse shops",
            "desc": "The \"Shops\" button shows the list of shops created by PRO members on Harmonia."
          },
          "step5": {
            "title": "Create your shop and website (PRO)",
            "desc": "As a PRO member, the Market's \"Settings\" ⚙️ button lets you create your own shop. Harmonia then generates a real website for your shop, accessible via a functional public URL link on the web, in addition to being visible directly on the platform."
          },
          "step6": {
            "title": "Customize your shop's website (PRO)",
            "desc": "From \"Settings\", customize the design and many settings of your shop's website: layout, presentation, and other visual elements, to make it your own."
          },
          "step7": {
            "title": "Publish products (PRO)",
            "desc": "Still from \"Settings\", add and update your shop's products. Each published product automatically gets its own web link, allowing it to be viewed and shared directly."
          },
          "step8": {
            "title": "Manage followed shops",
            "desc": "In \"Settings\", find the list of shops you follow. You can unfollow a shop at any time from this screen."
          },
          "step9": {
            "title": "Find your saved products",
            "desc": "Still in \"Settings\", view the list of products you've saved while browsing the Market."
          }
        }
      }
    }
  },
  "politiqueCookies": {
    "title": "Cookie Policy",
    "stats": {
      "sections": "Sections",
      "zeroTracking": "Zero tracking",
      "essentialOnly": "Essential cookies only"
    },
    "sections": {
      "definition": {
        "title": "What is a cookie?",
        "p1": "A cookie is a small text file placed on your device (computer, tablet, smartphone) while browsing. It allows the platform to remember certain information to improve your experience.",
        "highlight1": "Cookies cannot damage your device and contain no virus."
      },
      "politique": {
        "title": "Harmonia and cookies",
        "p1": "Harmonia adopts a strict and minimalist policy regarding cookies.",
        "highlight1": "We use no cookies for external advertising purposes, profiling, or third-party tracking.",
        "p2": "No external analytics tool (such as Google Analytics) is used. Your browsing data is never transmitted to outside advertising partners."
      },
      "utilises": {
        "title": "Cookies we use",
        "p1": "Harmonia only uses technical cookies strictly necessary for the platform to function properly.",
        "sub1": "Session and authentication cookies",
        "p2": "Keep you signed in to your Harmonia account. Created when your session opens, they are deleted by default when it closes.",
        "highlight1": "You may choose to stay signed in: in that case, a persistent authentication token is kept to avoid re-entering your password. This choice is yours and remains changeable at any time.",
        "sub2": "Cookies related to third-party providers (Google, etc.)",
        "p3": "When you sign in via Google or another provider, that provider may set its own cookies as part of the authentication process. These are governed by their own privacy policy.",
        "sub3": "Security cookies",
        "p4": "Help protect your account against fraud attempts and unauthorized access.",
        "sub4": "Payment-related cookies",
        "p5": "During a transaction (subscription, paid contest, pro shop), payment providers may set technical cookies limited to the duration of the transaction to ensure its security."
      },
      "nonUtilises": {
        "title": "Cookies NOT used",
        "p1": "For full transparency, here is what Harmonia does not use:",
        "bullets1": [
          "Advertising cookies — no external advertising, no targeting",
          "Third-party analytics tracking cookies — no external analytics tool",
          "Behavioral profiling cookies — no advertising profile built"
        ]
      },
      "mobile": {
        "title": "Mobile app",
        "p1": "In the Harmonia mobile app, cookies in the strict sense are not used. Similar technologies (secure authentication tokens, local storage) are used to ensure proper functioning.",
        "highlight1": "If you choose to stay signed in, an authentication token is kept locally on your device. You remain in control of this choice and can sign out at any time to remove it.",
        "p2": "This data is stored only on your device and is never shared with third parties for advertising purposes."
      },
      "duree": {
        "title": "Retention period",
        "bullets1": [
          "Session cookie — deleted when the session closes",
          "Authentication cookie — for the duration of your active session, or until explicit sign-out if \"stay signed in\" is enabled",
          "Security cookie — for the duration of your active session",
          "Payment cookie — for the duration of the transaction only"
        ]
      },
      "gestion": {
        "title": "Managing your cookies",
        "sub1": "Via your browser",
        "bullets1": [
          "Google Chrome: Settings › Privacy and security › Cookies",
          "Mozilla Firefox: Settings › Privacy & Security › Cookies",
          "Safari: Preferences › Privacy › Cookies",
          "Microsoft Edge: Settings › Privacy › Cookies"
        ],
        "highlight1": "Warning: disabling essential technical cookies may prevent you from signing in to Harmonia.",
        "sub2": "Via your mobile device",
        "p1": "Manage the Harmonia app's permissions directly from your iOS or Android device settings.",
        "sub3": "\"Stay signed in\" option",
        "p2": "On web as on mobile, this option is optional and remains under your exclusive control. Manually signing out removes the associated cookie or token."
      },
      "modifications": {
        "title": "Changes to the policy",
        "p1": "Harmonia reserves the right to modify this policy at any time, particularly in the event of technical developments or regulatory changes. Users will be informed of any change via the platform.",
        "highlight1": "Continued use after a change constitutes acceptance of the new terms."
      },
      "contact": {
        "title": "Contact",
        "p1": "See our user guide available directly on Harmonia for any further questions."
      }
    }
  },
  "reglesCommunautaires": {
    "title": "Community Rules",
    "stats": {
      "sections": "Sections",
      "forEveryone": "For everyone",
      "healthyCommunity": "Healthy community"
    },
    "sections": {
      "respect": {
        "title": "Respect and kindness",
        "p1": "Harmonia is a space for sharing and expression. Every member must treat others with respect, regardless of their origin, culture, religion, gender, age, or opinions.",
        "sub1": "It is prohibited to:",
        "bullets1": [
          "Insult, humiliate, or demean another member",
          "Harass, threaten, or intimidate a person or group",
          "Make discriminatory or contemptuous remarks toward a community",
          "Encourage or glorify violence in any form"
        ]
      },
      "contenuInterdit": {
        "title": "Prohibited content",
        "p1": "The following content is strictly prohibited on Harmonia, regardless of its form or visibility level:",
        "sub1": "Sexual content and nudity",
        "p2": "Any post of an explicit sexual nature or containing nudity is prohibited.",
        "sub2": "Hate and discrimination",
        "p3": "Any content inciting hatred toward a person or group because of their race, ethnicity, religion, nationality, gender, sexual orientation, or disability.",
        "sub3": "Violence and shocking content",
        "p4": "Content depicting real acts of violence, torture scenes, mutilation, or any content likely to traumatize members.",
        "sub4": "Misinformation",
        "p5": "Deliberately publishing false information with the intent to deceive, manipulate, or harm is prohibited.",
        "sub5": "Privacy violation & Impersonation",
        "bullets1": [
          "Publishing a third party's personal information without their consent",
          "Impersonating another person, brand, or official entity"
        ]
      },
      "publications": {
        "title": "Posting rules",
        "sub1": "Daily limit",
        "bullets1": [
          "Standard users: 1 post per day",
          "PRO users: 3 posts per day"
        ],
        "highlight1": "This limit strengthens the quality of shared information and encourages quality over quantity.",
        "sub2": "Authenticity of content",
        "p1": "You agree to publish only content you have authored or for which you hold the necessary rights.",
        "sub3": "Responsibility based on visibility",
        "p2": "You are solely responsible for your content, regardless of the chosen visibility level. PRO visibility, accessible to the entire community and included within its own limit of 3 daily posts, implies increased responsibility."
      },
      "messagerie": {
        "title": "Messaging and groups",
        "p1": "Rules of respect and kindness also apply to private messaging and discussion groups. The private nature of an exchange never justifies disrespectful behavior.",
        "highlight1": "Sending unsolicited commercial, advertising, or harassing messages is prohibited."
      },
      "concours": {
        "title": "Contests and competitions",
        "sub1": "Authenticity of entries",
        "p1": "Each participant must submit only original creations of which they are the author. Any fraud or plagiarism results in immediate and permanent disqualification.",
        "sub2": "Voting integrity",
        "bullets1": [
          "Voting in exchange for compensation (money, services) is prohibited",
          "Using automated tools to manipulate votes is prohibited",
          "Voting multiple times via multiple accounts is prohibited"
        ],
        "highlight1": "Each authenticated user has a single vote per candidate. Any circumvention results in the suspension of the votes involved.",
        "sub3": "Respect among competitors",
        "p2": "Any belittling, mockery, or attack toward another participant is prohibited. Competition must remain healthy and respectful.",
        "sub4": "Strategy and trivia games",
        "p3": "Games (checkers, Awalé, True or False…) must be played fairly. Using assistance software or any unfair means is prohibited.",
        "sub5": "Real-time information",
        "p4": "Harmonia broadcasts real-time information about contest proceedings and platform activity, so that all users are informed fairly and at the same time. Any attempt to manipulate or hijack this broadcast is prohibited."
      },
      "publicite": {
        "title": "Advertising and commercial content",
        "p1": "Only users who have subscribed to a Harmonia advertising plan are authorized to publish advertising content on the platform.",
        "highlight1": "Any unauthorized commercial solicitation, promotion of illegal activities, or distribution of fraudulent links is strictly prohibited."
      },
      "boutiques": {
        "title": "Pro shops",
        "p1": "PRO users can create a shop on the platform, accessible via Harmonia and via a public URL link on the web. Each published product has its own web link.",
        "highlight1": "Rules regarding prohibited content and advertising apply fully to the content of a pro shop and its products, including when accessed via a public web link.",
        "sub1": "Specific prohibitions",
        "bullets1": [
          "Selling or offering illegal products or services",
          "Publishing misleading information about the products offered",
          "Using the shop for scams or abusive data collection from visitors"
        ],
        "p2": "The PRO user is solely responsible for their shop's content. Any non-compliant shop or product may be suspended, including by deactivating the associated web link."
      },
      "signalement": {
        "title": "Reporting",
        "sub1": "How to report",
        "p1": "If you notice content that violates the rules, report it using the feature provided for this purpose on the platform.",
        "sub2": "Handling of reports",
        "bullets1": [
          "Report threshold reached → content placed under review (not visible)",
          "Compliant content → regains its normal visibility",
          "Non-compliant content → suspended permanently"
        ],
        "highlight1": "Any misuse of the reporting feature is itself contrary to the community rules."
      },
      "sanctions": {
        "title": "Consequences of violations",
        "sub1": "Content suspension",
        "p1": "Any content deemed contrary to the rules is suspended permanently and without appeal. Harmonia does not ban users; measures target content, not people.",
        "sub2": "No refund",
        "p2": "The suspension of paid content (PRO visibility or pro shop) does not give rise to any refund.",
        "sub3": "Personal responsibility",
        "highlight1": "In the event of a serious violation of applicable laws, Harmonia reserves the right to forward the necessary information to the competent authorities if required by law."
      },
      "api": {
        "title": "Prohibition of API access",
        "p1": "Harmonia's backend API and technical systems are reserved for exclusively internal use by the platform. It is strictly prohibited to:",
        "bullets1": [
          "Access the API outside of official applications",
          "Use scripts, bots, or automated tools to extract data",
          "Circumvent security or authentication systems",
          "Intercept communications between applications and servers",
          "Exploit or attempt to exploit any technical vulnerability"
        ],
        "highlight1": "These acts constitute serious offenses liable to legal action. Harmonia cooperates with the competent authorities to identify and prosecute offenders.",
        "p2": "Any discovered vulnerability must be reported to harmonia@harmoniaworld.world without being exploited."
      },
      "evolution": {
        "title": "Evolution of the rules",
        "p1": "Harmonia reserves the right to update these rules at any time, based on the platform's development and the community's needs.",
        "highlight1": "Continued use after a change constitutes acceptance of the new rules."
      },
      "contact": {
        "title": "Contact",
        "p1": "See our user guide available directly on Harmonia for any questions."
      }
    }
  },
  "actuScreen": {
    "toasts": {
      "noConnection": "No internet connection",
      "mediaAccessRequired": "Media access required.",
      "imageAdded": "Image added!",
      "videoAdded": "Video added!",
      "cannotAddMedia": "Unable to add media",
      "contentRequired": "Content is required",
      "limitReached": "Posting limit reached.",
      "postPublished": "Post published!",
      "cannotPublish": "Unable to publish",
      "reportRegistered": "Report submitted!",
      "reportError": "Error submitting report",
      "networkError": "Network error",
      "postSanctioned": "Post sanctioned ({{status}})",
      "adminError": "Administration error"
    },
    "offlineBanner": "No connection — Offline",
    "doubleTapToShow": "Double-tap to show",
    "loading": "Loading...",
    "upToDate": "You're all caught up ✓",
    "report": {
      "title": "Report",
      "message": "Report this post?",
      "confirm": "Yes, report",
      "cancel": "Cancel"
    },
    "filters": {
      "all": "All",
      "posts": "Posts",
      "images": "Images",
      "videos": "Videos",
      "music": "Music"
    },
    "filterMenu": {
      "title": "Show"
    },
    "adminStrike": {
      "title": "Direct Strike",
      "selectSanction": "Select the sanction:",
      "pending": "Set to pending",
      "lock": "Lock (Active)",
      "cancel": "Cancel"
    },
    "empty": {
      "offlineTitle": "No offline content",
      "emptyFeedTitle": "Your news feed is empty",
      "offlineSubtitle": "Reconnect to load your news feed.",
      "emptyFeedSubtitle": "Add friends to discover their posts, creations, and performances.\n\nThe more active friends you have, the livelier your feed will be! 🎨"
    },
    "createPost": {
      "title": "New post",
      "placeholder": "What's new?",
      "videoReady": "Video ready",
      "photo": "Photo",
      "video": "Video",
      "publish": "Post"
    },
    "visibility": {
      "public": "Public",
      "friends": "Friends",
      "pro": "PRO",
      "private": "Private"
    },
    "postDetails": {
      "title": "📊 Details",
      "author": "Author:",
      "published": "Published:",
      "reactions": "Reactions:",
      "close": "Close"
    }
  },
  "tabsLayout": {
    "offlineText": "No internet connection",
    "tabs": {
      "actu": "Feed",
      "games": "Games",
      "market": "Market",
      "messages": "Messages",
      "friends": "Friends",
      "profile": "Profile"
    }
  },
  "gamesScreen": {
    "header": {
      "pill": "Talent Hub",
      "title": "Reveal your Talent"
    },
    "infoBanner": {
      "title": "🏆 Harmonia — Talent Hub",
      "text": "Welcome to Harmonia, the platform that reveals and celebrates the talents of our community. Take part in challenges, compete with friends, show what you've got — and win trophies awarded publicly in front of the whole community. New challenges, new disciplines, new chances to shine every week. Your talent deserves to be seen. Your victory deserves to be celebrated. Join the movement. Reveal your talent. Harmonia awaits you. 🎯"
    },
    "chooseDiscipline": "CHOOSE YOUR DISCIPLINE",
    "longPressHint": "Long-press a game for more details",
    "footerNote": "New content added every week — stay tuned!",
    "trophiesAwardedPublicly": "Trophies awarded publicly in front of the community",
    "startAdventure": "Start the adventure",
    "categories": {
      "strategie": {
        "title": "Strategy Games",
        "description": "Thought & tactics",
        "items": {
          "s1": {
            "title": "Awalé",
            "tagline": "The ancestral art of strategy",
            "detail": "Master the ancestral art of Awalé and challenge your friends in strategic matches of rare intensity. Every seed sown, every decisive capture brings you closer to the top of the leaderboard. Harmonia's greatest tacticians will have their trophy awarded publicly in front of the whole community — because victory deserves to be celebrated in the open."
          },
          "s2": {
            "title": "Checkers",
            "tagline": "Dominate the board, rule the stage",
            "detail": "Face your opponents in pure strategy duels on the checkerboard. Anticipate every move, dominate every exchange, and capture your way up Harmonia's leaderboard. Champions are crowned publicly — their trophy, awarded in front of the entire community, is a testament to an excellence that commands admiration."
          }
        }
      },
      "connaissance": {
        "title": "Knowledge Games",
        "description": "Test your knowledge",
        "items": {
          "c1": {
            "title": "True or False",
            "tagline": "Challenge your friends with facts",
            "detail": "Test the breadth of your knowledge and challenge your friends in intellectual duels as thrilling as they are unpredictable. Answer True or False with precision and conviction, level up, and climb Harmonia's leaderboard. Your trophies will be awarded publicly, in front of the whole community — because knowledge, at its peak, deserves its crown."
          }
        }
      },
      "arts": {
        "title": "Arts",
        "description": "Creativity & expression",
        "items": {
          "a1": {
            "title": "Photography",
            "tagline": "Your eye, your signature",
            "detail": "Photography is a view of the world that only you possess. Submit your most striking shots, get noticed by the Harmonia community, and receive trophies awarded publicly in tribute to your exceptional artistic eye. On Harmonia, your vision deserves to be showcased, admired, and celebrated at its true worth."
          },
          "a2": {
            "title": "Drawing",
            "tagline": "Your line, your world",
            "detail": "Your line is your signature, your style is your identity. Share your drawings with the Harmonia community, stir minds, and be rewarded with trophies awarded publicly in recognition of your creative genius. Art only lives through those brave enough to show it — and Harmonia is your stage."
          },
          "a3": {
            "title": "Design",
            "tagline": "Aesthetics in service of intention",
            "detail": "Design is where aesthetics meets intention, where form meets meaning. Showcase your boldest visual creations on Harmonia, inspire your community, and earn trophies awarded publicly. A great designer deserves great recognition — and Harmonia gives you the platform you need."
          }
        }
      },
      "performance": {
        "title": "Performance",
        "description": "Take the stage",
        "items": {
          "p1": {
            "title": "Comedy",
            "tagline": "Laughter, the most universal art",
            "detail": "Laughter is the most universal and precious of human talents. Take the Harmonia stage, energize the community with your humor, your sense of timing, and your unmatched stage presence. The best comedians will have their trophies awarded publicly — because making people laugh is an art that deserves to be honored before everyone."
          },
          "p2": {
            "title": "Dance",
            "tagline": "Every move tells a story",
            "detail": "Every move tells a story words can't express. Share your dance talent with the Harmonia community — grace, power, creativity, emotion — and earn trophies awarded publicly, in tribute to your absolute mastery of the stage. Dance is a universal language: Harmonia is your podium."
          },
          "p3": {
            "title": "Theater",
            "tagline": "Embody, captivate, transcend",
            "detail": "Dramatic art is the deepest and truest expression of the human soul. Embody your characters with intensity, captivate your audience, and make every performance an unforgettable moment. On Harmonia, great theater actors are crowned publicly — your talent deserves its spotlight, its ovation, its consecration."
          }
        }
      },
      "musique": {
        "title": "Music",
        "description": "Make the stage vibrate",
        "items": {
          "m1": {
            "title": "Singing",
            "tagline": "Your voice, your most precious instrument",
            "detail": "Your voice is your most precious instrument, your tone is your mark on the world. Whether you perform pure a cappella or accompanied, let your voice resonate throughout the Harmonia community. Trophies are awarded publicly — because great voices deserve their ovation, their recognition, and their spotlight."
          },
          "m2": {
            "title": "Piano",
            "tagline": "88 keys, an infinite universe",
            "detail": "The piano's 88 keys hold an entire universe — from melancholic tenderness to storms of passion. Show your virtuosity, amaze the Harmonia community with the richness of your playing, and receive trophies awarded publicly in recognition of your exceptional mastery and musical sensitivity."
          },
          "m3": {
            "title": "Guitar",
            "tagline": "Every chord, a statement",
            "detail": "Whether acoustic, electric, or classical, the guitar has the power to stir souls and transcend borders. Share your performances with the Harmonia community — every riff, every solo, every chord brings you closer to the top. Get crowned at public trophy ceremonies, in front of everyone."
          }
        }
      },
      "artisanat": {
        "title": "Craftsmanship",
        "description": "Skill & trades of excellence",
        "items": {
          "ar1": {
            "title": "Sewing",
            "tagline": "The art that dresses the world",
            "detail": "Sewing is an age-old art that dresses the world with precision and elegance. Show your creations, your attention to detail, and your mastery of the needle to the Harmonia community. Your trophies will be awarded publicly — because excellence in craft deserves to be honored, showcased, and celebrated before everyone."
          },
          "ar2": {
            "title": "Woodworking",
            "tagline": "Wood in your hands becomes art",
            "detail": "Wood in your hands becomes architecture, beauty, and utility. Share your most remarkable creations with the Harmonia community and receive trophies awarded publicly, in tribute to the nobility of your craftsmanship. Woodworking is a demanding art — Harmonia gives it the honor it deserves."
          },
          "ar3": {
            "title": "Hairstyling",
            "tagline": "Enhance, transform, reveal",
            "detail": "Hairstyling transforms, beautifies, and reveals the best in people. Present your boldest hair creations to the Harmonia community and earn trophies awarded publicly — because the art of enhancing others is a rare gift that deserves its finest, fairest recognition."
          },
          "ar4": {
            "title": "Welding",
            "tagline": "The precision that joins metals",
            "detail": "Welding fuses metals, ingenuity, and precision into a single masterful gesture. Share your technical expertise and your most impressive work with the Harmonia community. Your trophies will be awarded publicly — rigor, precision, and craftsmanship excellence deserve their crown and recognition."
          },
          "ar5": {
            "title": "Mechanics",
            "tagline": "The science that keeps the world turning",
            "detail": "Mechanics is the science that literally keeps the world turning. Demonstrate your expertise, share your most elaborate technical work with the Harmonia community, and receive trophies awarded publicly in tribute to your exceptional mastery of machines, engines, and engineering. Mechanical excellence deserves its podium."
          }
        }
      }
    }
  }
}
